import { useNavigate } from 'react-router-dom';
import { Button } from '@appkit4/react-components';
import { AppRoutes } from 'Constants';
import useLocale from 'locale/useLocale';
import { useFormikContext } from 'formik';

export type SubmissionStepFourProps = {
    submissionIdForEditFlow?: string;
};

const SubmissionStepFour = ({
    submissionIdForEditFlow,
}: SubmissionStepFourProps) => {
    const navigate = useNavigate();
    const { l } = useLocale();
    const { resetForm } = useFormikContext();

    return (
        <>
            <p>{l('_submissionDelay')}</p>
            <div className="d-flex justify-content-end mt-4">
                <div className="me-2">
                    <Button
                        kind="secondary"
                        onClick={() => {
                            resetForm();
                            navigate(AppRoutes.HomePage);
                        }}
                    >
                        {l('_home')}
                    </Button>
                </div>
                <div>
                    <Button
                        kind="primary"
                        onClick={() => navigate(AppRoutes.History)}
                    >
                        {l('_viewPreviousSubmissions')}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default SubmissionStepFour;
